:host {
  width: auto;
  height: auto;
}

.file-names-wrapper {
  padding-top: var(--spacer);
  display: flex;
}
